export default {
  v2: {
    change: 'Өөрчлөх',
    remove: 'Арилгах',
    auto_background: 'Автомат арын дэвсгэр',
    create_new_course_org: 'Байгууллагадаа шинэ курс үүсгэх.',
    create_new_course_marketplace: 'Зах зээлд зориулан шинэ курс үүсгэх.',
    create_new_course_both:
      'Байгууллага болон зах зээлд зориулсан шинэ курс үүсгэх.',
    ok: 'За ',
    page_bg: 'Хуудасны арын дэвсгэр',
    lesson_cover: 'Хичээлийн нүүр зураг',
    create_skill_journey: 'Ур чадварын аялал үүсгэх',
    scroms: 'Скормууд',
    min_score_pass: 'Хамгийн бага босго оноо',
    no_scorms_available: 'Скорм байхгүй байна.',
    no_events_available: 'Эвент байхгүй байна.',
    no_courses_available: 'Курс байхгүй байна.',
    no_courses_baskets: 'Сагсанд курс байхгүй.',
    no_mazes_baskets: 'Сагсанд мэйз байхгүй.',
    no_scroms_baskets: 'Сагсанд скорм байхгүй.',
    no_events_baskets: 'Сагсанд эвент байхгүй.',
    sorry: ' Уучлаарай!',
    option_1: 'Сонголт 1',
    option_2: 'Сонголт 2',
    enter_number_words: ' Үгийн тоо оруулах',
    summarize: 'Хураангуйлах',
    answer: 'Хариулах',
    hold_tight_one_minute:
      'Түр хүлээгээрэй, бид бэлтгэж байна. Нэг минут болно.',
    enter_question: 'Асуултаа оруулна уу',
    enter_relevant_documents: 'Холбогдох баримт бичгийн тоог оруулна уу',
    please_input_relevant_documents: 'Холбогдох баримт бичгийг оруулна уу!',
    please_wait_loading_results: 'Илэрцийг ачаалах хүртэл хүлээнэ үү...',
    proceed_to_add_voice: 'Дуу нэмэхээр үргэлжлүүлэх',
    results: 'Илэрц',
    no_result_found_try_asking_questions:
      'Илэрц олдсонгүй. Нэмж асуулт асууж үзнэ үү',
    eg: 'жишээ',
    what_make_sales_manager: 'Худалдааны менежер болоход юу шаардлагатай вэ',
    please_select_lang: ' Хүссэн хэлээ сонгоно уу!',
    search: 'Хайх',
    please_copy_desired_content:
      'Хүссэн контентоо зүүн гар талын савнаас баруун гар талын сав руу хуулна уу',
    rating_req: 'Заавал үнэлгээ өгөх шаардлагатай.',
    review_req: ' Заавал сэтгэгдлээ өгөх шаардлагатай.',
    rating_review_req: 'Заавал үнэлгээ, сэтгэгдлээ өгөх ёстой.',
    how_rate_this: 'Үүнийг та хэрхэн үнэлэх вэ',
    amazing_above_expectations: 'Гайхалтай, төсөөллөөс илүү!',
    certificates: 'Сертификатууд ',
    you_no_certificates: 'Танд одоогоор сертификат байхгүй байна.',
    please_add_review: 'Үнэлгээ өгөхдөө сэтгэгдлээ бичнэ үү. Баярлалаа.',
    post: 'Нийтлэх',
    rate: 'Үнэлэх',
    avg_rating: 'Дундаж үнэлгээ',
    no_review_found: 'Сэтгэгдэл олдсонгүй',
    are_sure_to_disale_zoom_integration:
      'Та Zoom холболтыг салгахдаа итгэлтэй байна уу?',
    badges: 'Тэмдгүүд',
    you_no_badge_available: 'Танд одоогоор тэмдэг байхгүй байна.',
    download_certificate: 'Сертификат татах',
    loading: 'Ачаалж байна...',
    no_file_attached: 'Хавсаргасан файл байхгүй',
    you_do_not_have_any_notes: 'Танд тэмдэглэл байхгүй.',
    question: 'Асуулт',
    score: 'Оноо',
    alert_score_message: 'хүн оноогоо илгээсэн байна.',
    alert_question_message: 'Шинээр асуулт нэмэгдээгүй байна.',
    button_submit: 'Илгээх',
    button_allScores: 'Бүх оноог илгээсэн.',
    record_wait: 'Бичлэг хийгдэж байна. Түр хүлээнэ үү...',
    buttonSubmit_warning: 'Илгээхийн өмнө бүх оноог оруулна уу',

    // List.jsx @Added:Mahesh
    upload_ar_assets: 'AR ассет байршуулах',
    edit_ar_assets: 'AR ассет засварлах',
    upload_assets: 'Ассет байршуулах',

    // ARUploads.jsx @Added:Mahesh
    trigger_title: 'Гарчиг эхлүүлэх',
    trigger_description: 'Эхлүүлэх тайлбар',
    please_type_target_description: 'Бай тайлбараа бичнэ үү',
    trigger_image: 'Эхлүүлэх зураг*',
    upload_trigger_image: 'Эхлүүлэх зургаа оруулна уу',
    drag_n_drop: 'Чирч ирээд оруулах',
    file_size_should_not_exceed: '(Файлын хэмжээ 2 MB-ээс хэтэрч болохгүй)',
    ar_content: 'AR контент *',
    upload_3d_zip: '3D Zip байршуулах',
    content_attached: 'Контент хавсаргасан.',
    enter_trigger_image_title: 'Эхлүүлэх зургийн гарчиг оруулна',
    ar_preview_image: 'AR урьдчилан харах зураг',
    upload_preview_image: 'Урьдчилан харах зураг байршуулах',
    creating___: 'Үүсгэж байна...',
    updating___: 'Шинэчилж байна...',
    create: 'Үүсгэж байна',
    update: 'Шинэчлэх',
    ar_assets: 'AR зураг',
    _3d_files_mp4: '(Нягтруулсан .OBJ, .FBX)',
    persons_have_submitted_their_scores: 'хүн оноогоо илгээсэн байна.',
    no_questions_added_till_now: 'Одоог хүртэл асуулт нэмэгдээгүй байна ',
    submit: 'Илгээх',
    all_scores_submitted: 'Бүх оноог илгээсэн.',
    recording_is_starting: 'Бичлэг хийгдэж байна. Түр хүлээнэ үү...',
    please_input_scores_before_submitting:
      'Илгээхийн өмнө бүх оноог оруулна уу',
    //EventMenus.jsx
    end_for_all: 'Бүгдийг дуусгах',
    full_screen: 'Бүтэц дэлгэц',
    breakout_room: 'Завсарлагын өрөө',
    //ChimeConference.jsx
    send_invitations: 'Илгээсэн урилга(ууд)',
    add_participants: 'Оролцогч(ид) нэмэх',
    create_breakout_room: 'Завсарлагын өрөө үүсгэх',
    //AntMediServeice.jsx
    connecting: 'Холбож байна...',
    //AntPlayer.jsx
    currently_broadcaster_unavailable: 'Өргөн дамжуулагч одоогоор байхгүй.',
    //BreakoutForm.jsx
    how_many_breakout_room_to_create: 'Хэдэн завсарлагын өрөө үүсгэх вэ?',
    create_upto_three_breakout_rooms: '*3 хүртэлх завсарлагын өрөө үүсгэх',
    //PassiveUsers/index.js
    allow: 'Зөвшөөрөх',
    //PreviewHeader.jsx
    additional: 'Нэмэлт',
    attachment: 'Хавсралт',
    //EventOverview.jsx
    no_description_available: 'Тайлбар байхгүй.',
    //EventParticipants.jsx
    people: 'ХҮМҮҮС',
    waiting: 'Хүлээж байна',
    hand_raising_users: 'Гараа өргөсөн хэрэглэгчид -',
    invite: 'урих',
    //EventRooms.jsx
    create_room: 'Өрөө үүсгэх',
    //Header.jsx
    create_live_event: 'Шууд эвент үүсгэх',
    //Detail.jsx
    support_upto_fivethousand_participants:
      'Энэхүү эвентэд 5000 хүртэлх оролцогч хамрагдах боломжтой event',
    support_upto_ten_participants:
      '10 хүртэлх видео оролцогч хамрагдах боломжтой',
    support_upto_twohundred_participants:
      'Энэхүү эвентэд 200 хүртэлх оролцогч хамрагдах боломжтой',
    supprt_upto_five_participants:
      '5 хүртэлх видео оролцогч хамрагдах боломжтой',
    support_upto_twentyfive_participants:
      'Энэхүү эвентэд 25 хүртэлх хүн шууд видеогоор орж болно.',
    two_live_video_participants:
      'Энэхүү эвентэд 2 хүн шууд видеогоор орж болно (зохион байгуулагч болон оролцогч)',
    you_can_have_upto_five_examinees: 'Зөвхөн 5 хүртэлх шалгагч байх боломжтой',
    you_can_have_upto_twentyfive_participants:
      'Та 25 хүртэлх оролцогч хамруулах боломжтой',
    you_can_have_upto_five_participants:
      'Та 5 хүртэлх оролцогч хамруулах боломжтой',
    you_can_have_upto_ten_participants:
      'Та 10 хүртэлх оролцогч хамруулах боломжтой',
    select_hosts_email: 'Зохион байгуулагчийн имэйлийг сонгоно уу',
    //Setting.jsx
    send_invite_email: 'Урих имэйл илгээх',
    do_not_send_invite_email: 'Урих имэйл бүү илгээ',
    error: 'Алдаа',
    //ShowContactsModal.jsx
    max_twentyfive_users_allowed: 'Хамгийн ихдээ 25 хүн сонгох боломжтой',
    max_five_users_allowed: 'Хамгийн ихдээ 5 хүн сонгох боломжтой',
    max_ten_users_allowed: 'Хамгийн ихдээ 10 хүн сонгох боломжтой',
    no_user_found: 'Хэрэглэгч олдсонгүй',
    //SwitchSettings.jsx
    transcribe_to: 'Хөрвүүлэх',
    //ZoomForm.js
    integrate_zoom_to_start_meeting:
      'Zoom уулзалт эхлүүлэх бол zoom-тэй холбоно уу.',
    zoom_is_not_integrated: 'Zoom холбогдоогүй байна',
    // Poll.jsx
    delete_poll: 'Санал хураалтыг устгах',
    add_poll: 'Санал хураалт нэмэх',
    /* @Added By: Prabin */
    //Events
    live_now: 'ШУУД ДАМЖУУЛЖ БАЙНА !!!',
    average_rating: 'Дундаж үнэлгээ',
    review: 'Хяналт',

    // Reports/Course/Details/Details.jsx
    time_spent: 'Зарцуулсан цаг',
    total: 'Нийт',
    /* @Added By: Furkan */
    // Reports/Events/Preview/Preview.jsx
    mins: 'Минут',
    /* @Added By: Furkan */
    // Reports/Lesson/Details/Internal/Quiz/Quiz.jsx
    no_data: 'Тааврын дата байхгүй байна',
    total_score: 'Нийт оноо',
    pass_score: 'Босго оноо',
    point: 'Оноо',
    /* @Added By: Furkan */
    // Reports/Lesson/Details/Internal/Quiz/QuizByUser/QuizByUser.jsx
    wrong: 'Буруу',
    response: 'Хариу',
    submitted: 'Илгээсэн',
    /* @Added By: Furkan */
    // Reports/LiveAssessments/Preview/Preview.jsx
    average: 'Дундаж',
    /* @Added By: Furkan */
    // Reports/Maze/Preview/Preview.jsx
    total_play: 'Нийт тоглолт',
    view_graph: 'График харах',
    time_spent_mins: 'Зарцуулсан хугацаа (минут)',
    play: 'Тоглох',
    ideal_path: 'Тохиромжтой зам',
    user_incorrect_path: 'Хэрэглэгч буруу зам',
    ideal_path_taken: 'Хэрэглэгч тохиромжтой зам сонгосон',
    scenario: 'Сценари',
    option: 'Сонголт',
    spend: 'Зарцуулах',
    /* @Added By: Furkan */
    // Reports/Report/Report.jsx
    average_spending_time: 'Дундаж зарцуулах хугацаа',
    activity_overview: 'Үйл ажиллагааны тойм',
    /* @Added By: Furkan */
    // Reports/Report/Report_.jsx
    live_event: 'Шууд эвент ',
    live_assessment: 'Шууд үнэлгээ',
    report_download: 'Тайлан татах',
    all_workshops: 'Бүх дасгал ажил',
    /* @Added By: Furkan */
    // Reports/User/Detail/Detail.jsx
    overview_average_activity: 'Үйл ажиллагааны ерөнхий дундаж',
    overview_workshop_graph: 'Дасгал ажлын графикийн тойм ',
    mazes: 'Мэйзүүд ',
    correct_feedback: 'Зөв санал сэтгэгдэл',
    incorrect_feedback: 'Буруу санал сэтгэгдэл',
    checkin_checkout: 'Бүртгүүлж орох – Бүртгүүлж гарах',
    minutes: 'минут',
    incorrect_path: 'Буруу зам',
    answer_not_available: 'Хариулт байхгүй байна',
    views: 'үзсэн тоо',
    item: 'зүйл',
    questions: 'Асуултууд',
    total_points: 'Нийт оноо',
    total_attempts: 'Нийт оролдлого',
    /* @Added By: Furkan */
    // Reports/User/Detail/Detail.jsx
    created_date: 'Үүсгэсэн огноо',
    host_name: 'Зохион байгуулагчийн нэр',
    host_section: 'Зохион байгуулагчийн хэсэг',
    /* @Added By: Furkan */
    // views/SkillJourney/SkillJourney.jsx
    choose_products: 'Бүтээгдэхүүн сонгох',
    add_to_basket: 'Сагсанд нэмэх',
    basket: 'Сагс',
    times: 'удаа',
    events: 'Эвентүүд',
    scorms: 'Скормууд',
    /* @Added By: Furkan */
    // views/SkillJourney/View/View.jsx
    skill_journey_overview: 'Skill Journey overview',
    /* @Added By: Furkan */
    // components/Header/internal/Informations/Informations.jsx
    how_to_use: 'Хэрхэн ашиглах вэ',
    live_broadcast_description:
      'БИД ХЯЛБАР АШИГЛАХ БОЛОМЖТОЙ ХИЧЭЭЛ БЭЛТГЭГЧИД ШУУД ВИДЕО ДАМЖУУЛАЛТЫГ ХОЛБОСОН',
    live_broadcast_subdescription:
      'ShareLook-ын патенттай шууд дамжуулах системийн тусламжтай та сургалтыг автоматжуулж, олныг хамруулж, мэдлэг түгээх явцыг улам боловсронгуй болгож болно.',

    // views/SkillJourney/PublishSkillJourney/PublishSkillJourney.jsx
    disclaimer: `Миний ур чадварын аялал дараахь зүйлийг хийхгүй гэдгийг би баталж байна.: 
  - аливаа гуравдагч этгээдийн эрхийг зөрчих
  - гүтгэлэг, садар самуун, ёс суртахуунгүй, садар самуун, садар самуун, хүчирхийлэлтэй, доромжилсон, доромжилсон, заналхийлсэн, ялгаварлан гадуурхсан агуулгатай, бүр одоор далдалсан аливаа хууль бус зүйлийг агуулсан байх.
  - бусад хүмүүст хувийн халдлагыг агуулсан
  - бусад оролцогчид, олон нийтийн зүтгэлтнүүд эсвэл олны танил хүмүүсийн дүр төрхийг агуулсан
  - Тухайн хүний зөвшөөрөлгүйгээр аливаа хувь хүний талаарх аливаа бичлэг, хувийн мэдээллийг агуулсан байх ба дэлхийн аль ч хэсэгт мэдээлэл хамгаалах журмыг зөрчөөгүй болно.
  - аливаа арилжааны уриалга эсвэл аливаа хэлбэрийг агуулсан “спам”'`,
    price: 'Үнэ',
    video_link: 'Видео холбоос',
    category: 'Ангилал',
    objectives: 'Зорилтууд',
    marketplace_description: 'Зах зээлийн тодорхойлолт',

    live_discussion: 'ШУУД ХЭЛЭЛЦҮҮЛЭГ',
    poll: 'САНАЛ АСУУЛГА',
    hide_grid: 'Сүлжээг нуух',
    show_grid: 'Торыг харуулах',
    stop_screen_share: 'Дэлгэц хуваалцахыг зогсоох',
    screen_share: 'Дэлгэц хуваалцах',
    mute: 'Дууг хаах',
    unmute: 'Дэлгэц хуваалцах',
    raise_hand: 'Гараа өргө',
    waiting__: 'Хүлээж байна...',
    audio_active: 'Аудио идэвхтэй'
  },
  general: {
    save: 'хадгалах',
    autosaved: 'Автоматаар хадгалсан',
    back_to: 'Буцах',
    by: 'Хийсэн хүн',
    chat: 'Чат',
    is_record: 'Бичлэг хийх ', // to translate
    completed: 'Гүйцээсэн',
    canceled: 'Цуцалсан',
    component: 'Бүрэлдэхүүн',
    confirm: 'Баталгаажуулах',
    course: 'Курс',
    date: 'Огноо',
    details: 'Деталь',
    empty: 'Дата байхгүй',
    enrolled: 'Элссэн',
    free: 'Үнэгүй',
    graph: 'График',
    loading: 'Ачаалж байна...',
    lesson: 'хичээл',
    lessons: 'хичээлүүд',
    live_assessment: 'Шууд үнэлгээ',
    live_event: 'Шууд эвент',
    maze: 'Мэйз', // to translate ,
    skill: 'Ур чадварын аялал', // to translate
    no: 'Үгүй',
    of: '-ын',
    or: 'Эсвэл',
    order: 'дараалал', // to translate
    organization: 'Байгууллага',
    page: 'Хуудас',
    pages: 'Хуудаснууд',
    personal: 'Хувийн',
    poll: 'Санал хураалт',
    rating: 'Үнэлгээ',
    reset: 'Тохиргоо хийх',
    signin: 'Нэвтрэх',
    signup: 'Бүртгүүлэх',
    soon: 'Удахгүй',
    type: 'Төрөл',
    uploading: 'Байршуулж байна...',
    yes: 'Тийм',
    something_went_wrong: 'Алдаа гарлаа!',
    view_all: 'Бүгдийг харах',
    upload_successful: 'Амжилттай байршлаа',
    upload_successful_message:
      'Таны excel баримт бичиг амжилттай байршиж, одоогоор ачаалж байна. Түр хүлээн үү.',
    check_email_upload_successful:
      'Хэрэглэгчийн жагсаалтыг <1>харах</1> бол <0>имэйл хаягаа шалгана уу</0>.',
    is_private: 'Хувийн',
    to_attach: 'Файл хавсаргах', // to translate
    file_attached: 'Файл хавсаргасан' // to translate
  },

  account: {
    title: 'Бүртгэл',
    subtitle: 'Тохиргоо, бүртгэлийн мэдээллээ удирдах.',
    saved: 'Бүртгэлийг амжилттай өөрчиллөө'
  },

  assessments: {
    title: 'Үнэлгээнүүд',
    subtitle: 'Үнэлгээ үүсгэх',
    finished: 'Үнэлгээ дууслаа ',
    countdown: 'Шууд үнэлгээг дамжуулах хугацаа',
    create: 'Үнэлгээ үүсгэх',
    list_title: 'Таны үнэлгээнүүд',
    delete_warning: 'Та үүнийг устгахдаа итгэлтэй байна уу?',
    details_title: 'Үнэлгээний дэлгэрэнгүй нэмэх',
    details_subtitle:
      'Үнэлгээнд нэр өгч, ямар зорилготой болохыг хүмүүст хэлнэ үү.',
    disclaimer: `Миний үнэлгээ дараах зүйлсийг зөрчөөгүй гэдгийг баталж байна:
    - аливаа гуравдагч талын эрхийг зөрчөөгүй
    - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
    - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
    - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
    - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
    - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй`, // added_first
    assessment_details: 'Үнэлгээний дэлгэрэнгүй', // to translate
    assessment_settings: 'Үнэлгээний тохиргоо' // to translate
  },

  buildersettings: {
    title: 'Нийтлэх тохиргоо',
    subtitle:
      'Эвентийн тохиргоо нэмэх, хэн таны эвентийг харах, үйлдэл хийх боломжтойг тохируулах event'
  },

  buttons: {
    market_place: 'Зах зээл',
    back_to_normal: 'Энгийн рүү буцах',
    add: 'Нэмэх',
    add_page: 'Хуудас нэмэх',
    add_lesson: 'Хичээл нэмэх',
    add_answer: 'Шинэ хариулт нэмэх',
    add_group: 'Групп нэмэх',
    add_organization: 'Байгууллага нэмэх',
    add_question: 'Асуулт нэмэх',
    add_quiz: 'Таавар нэмэх',
    add_users: 'Хэрэглэгч нэмэх',
    back: 'Буцах',
    back_to_maze: 'Мэйз сценари руу буцах', // to translate
    back_to_course: 'Курсийн тойм руу буцах',
    back_to_lesson: 'Хичээлийн тойм руу буцах',
    back_to_media: 'Медиа сан руу буцах',
    back_to_details: 'Деталь руу буцах',
    cancel: 'Цуцлах',
    clear: 'Арилгах',
    close: 'Хаах',
    clone: 'Клон хийх',
    close_lesson: 'Хичээлийг хаах',
    clone_course: 'Курсийг клон хийх',
    confirm: 'Баталгаажуулах',
    create: 'Үүсгэх',
    download: 'Татах',
    download_mass_user_tamplate: 'Загварыг татаж авах',
    add_mass_users: 'Масс хэрэглэгчид нэмэх',
    upload_excel_list: 'Excel жагсаалт байршуулах',
    delete: 'Медиа устгах',
    edit: 'Засварлах',
    edit_course: 'Курс засварлах',
    edit_maze: 'Мэйз засварлах', // to translate
    enroll: 'Элсэх',
    finish: 'Дуусгах',
    wait: 'Хүлээх...', // to translate
    retry: 'Дахин оролдох', // to translate
    upload_image: 'Зураг оруулах',
    upload_image_video: 'Зураг эсвэл видео оруулах',
    select_media_library: 'Медиа сан сонгох',
    make_public: 'Нийтэд нээлттэй болгох',
    make_private: 'Хувийн болгох',
    make_org: 'Байгууллага үүсгэх',
    media: 'Медиа сан',
    my_theme: 'Миний загвар',
    next: 'Дараагийн',
    next_lesson: 'Дараагийн хичээл',
    next_step: 'Дараагийн алхам',
    previous_step: 'Өмнөх алхам',
    publish: 'Нийтлэх',
    publish_assessment: 'Үнэлгээгээ нийтлэх',
    publish_course: 'Оноогоо нийтлэх',
    publish_scorm_course: 'СКОРМ курсээ нийтлэх', // to translate
    publish_event: 'Эвентээ нийтлэх',
    publish_maze: 'Мэйз нийтлэх', // to translate
    reset: 'Дахин тохируулах',
    reset_elements: 'Дахин тохируулах элементүүд',
    save: 'Хадгалах',
    creating: 'Үүсгэж байна...',
    updating: 'Шинэчилж байна...',
    saved: 'Хадгалсан',
    save_for_later: 'Дараа үзэхээр хадгалах',
    save_settings: 'Тохиргоог хадгалах',
    select_files: 'Файл сонгох',
    select_theme: 'Загвар сонгох',
    start_lesson: 'Хичээл эхлүүлэх',
    update: 'Шинэчлэх',
    import: 'Элементүүдийг импорт хийх', // to translate
    upload: 'Байршуулах',
    upload_audio: 'Аудио байршуулах',
    upload_photo: 'Профайл зураг байршуулах',
    upload_video: 'Видео байршуулах',
    enrolled: 'Элссэн',
    unenroll: 'Элсэхээ болих',
    from_library: 'Медиа сан',
    remove: 'Устгах',
    removed: 'Устгасан',
    start_broadcast: 'Өргөн дамжуулалт эхлүүлэх',
    end_broadcast: 'Өргөн дамжуулалт дуусгах',
    camera: 'Камер',
    screen: 'Дэлгэц',
    screen_with_camera: 'Камертай дэлгэц',

    // added_first
    insert: 'Оруулах', // to translate
    inserting: 'Оруулж байна', // to translate

    upload_pdf: 'PDF байршуулах', // to translate

    portrait: 'Босоо зураг', // to translate
    landscape: 'Хөндлөн зураг', // to translate
    import_from_library: 'Медиа сангаас текст импорт хийх', // to translate
    question_answer_ai: 'Асуулт хариулт хиймэл оюун ухаан', // to translate

    //maze
    take_maze: 'МЭЙЗ ХИЙХ' // to translate
  },

  card: {
    quick_add: 'Түргэн нэмэх',
    add: 'Нэмэх',
    clone: 'Клон хийх',
    completed: 'Гүйцээсэн хичээлүүд'
  },

  course: {
    upcoming_course: 'Дараагийн курс',
    unPublishEvent: 'Эвентийг нийтлэхээ болих',
    unPublishAssessment: 'Үнэлгээг нийтлэхээ болих',
    unPublishMaze: 'Мэйз нийтлэхээ болих', // to translate
    pastCourse: 'Бэлтгэх курс',
    upcoming: 'Дараагийн шууд эвент',
    upcomingMaze: 'Дараагийн мэйз', // to translate
    pastMaze: 'Өмнөх мэйз', // to translate
    pastEvent: 'Өмнө шууд эвент',
    pastAssessment: 'Өмнөх шууд үнэлгээ',
    upcomingAssessment: 'Дараагийн шууд үнэлгээ',
    created: 'Үүсгэсэн огноо:',
    assignees: 'Хуваарилсан хүмүүс',
    organisations:
      '{{ organizations }} Байгууллагууд, <2> {{ users }} хэрэглэгчид</2>',
    event_date: 'Шууд эвентийн огноо <1> {{ date }} </1>',
    delete_warning: 'Үүнийг устгахдаа та итгэлтэй байна уу',
    clonning_no_lesson:
      'Энэ Курсийг клон хийхийн тулд багадаа нэг Хичээл нэмнэ үү.',
    clone_warning: 'Үүнийг клон хийхдээ та итгэлтэй байна уу',
    clone_success: 'клон хийж байна',
    disclaimer: ` Миний курс дараах зүйлсийг агуулаагүй гэдгийг баталж байна:
    - аливаа гуравдагч талын эрхийг зөрчөөгүй
  - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
  - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
  - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
  - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
  - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй `
  },

  coursecreate: {
    dropzone_text: 'Медиа оруулах',
    sidebar_text: 'Хичээлдээ <1/> зориулан <3/> загвар сонгоно уу',
    delete_warning: 'Та энэ хичээлийг устгахдаа итгэлтэй байна уу?'
  },

  coursepage: {
    quizview_loading: 'Хариултыг шалгаж байна. Хүлээнэ үү...',
    quizview_answer: 'Таны хариулт'
  },

  coursequiz: {
    title: 'Бүх хичээлд таавар бий'
  },

  dashboard: {
    tooltip_title: 'Энэ видеог дахиж бүү харуул',
    page_title: 'Таны курсүүдийн тоон үзүүлэлт',
    page_subtitle: 'Үүсгэсэн курсүүдийн статус',
    profile_add_info:
      'Профайлаа гүйцээхийн тулд <1>{{uncompletedText}}</1> нэмнэ үү.',
    profile_build:
      'Профайлаа <1>энд</1> үүсгэн, өөрийн сонирхол, ур чадварын талаар бидэнд хэлээрэй.',
    profile_title: 'Профайлын чансаа',
    more_details: 'Дэлгэрэнгүй деталь'
  },

  errors: {
    answer: 'Хариултаа оруулна уу',
    answer_correct: 'Зөв хариулт сонгоно уу',
    author: `Зохиогчийн нэрийг оруулна уу`, // to translate
    category: 'Ангилал сонгоно уу', //to translate
    course_outline: 'Курсийн агуулгыг оруулна уу', // to translate
    course_obj: 'Курсийн зорилтыг оруулна уу', // to translate
    course_description: 'Курсийн тайлбарыг оруулна уу', // to translate
    maze_outline: 'Мэйзийн агуулгыг оруулна уу', // to translate
    maze_obj: 'Мэйзийн зорилтыг оруулна уу', // to translate
    maze_description: 'Мэйзийн тайлбарыг оруулна уу', // to translate
    code: 'Кодоо оруулна уу',
    criterion: 'Шалгуураа оруулна уу',
    duration: 'Үргэлжлэх хугацаа шаардлагатай',
    element: 'Элемент оруулна уу',
    email: 'Имэйлээ оруулна уу',
    email_invalid: 'Имэйл буруу байна',
    feedback_correct: 'Оруулсан санал зөвлөмж зөв байна',
    feedback_incorrect: 'Оруулсан санал зөвлөмж буруу байна',
    host: 'Эвентийн зохион байгуулагчийг оруулна уу',
    host_assessment: 'Үнэлгээний зохион байгуулагчийг оруулна уу',
    image: 'Зураг оруулна уу',
    lessons: 'Хичээлийн тоог оруулна уу', // to translate
    location: 'Байршлаа оруулна уу',
    live_location: 'Өргөн нэвтрүүлгийн байршлаа оруулна уу',
    limit: 'Шууд дамжуулах хугацаагаа оруулна уу',
    min_3char: '3-аас доошгүй тэмдэгт',
    number: 'Эерэг тоо оруулна уу.',
    host_email_require: `Зохион байгуулагчийн имэйл шаардлагатай.`,
    attendee_email_require: `Оролцогчийн имэйл шаардлагатай.`,
    user_email_require: `Хэрэглэгчийн имэйл шаардлагатай.`, // to translate
    team_size: `Багийн хэмжээ шаардлагатай.`, //to translate
    name: 'Нэрээ оруулна уу',
    not_found_course: 'Курс олдсонгүй',
    not_found_event: 'Эвент олдсонгүй',
    not_found_assessment: 'Үнэлгээ олдсонгүй',
    organization: 'Байгууллага сонгоно уу', // to translate
    pass_score: '0-оос 100 хүртэл үнэлгээ оруулна уу', // to translate
    password: 'Нууц үгээ оруулна уу',
    password_digit: 'Нэгээс багагүй тэмдэгт',
    password_short: 'Нууц үг хэт богино байна, 10-аас доошгүй тэмдэгт.',
    password_special: 'Нэгээс доошгүй онцгой тэмдэгт байна',
    password_uppercase: 'Нэгээс доошгүй том үсэг байна',
    password_lowercase: 'Нэгээс доошгүй жижиг үсэг байна',
    phone: ' Утасны дугаараа оруулна уу',
    phone_invalid: 'Утасны дугаар буруу байна',
    position: 'Байрлалаа оруулна уу',
    price: 'Үнэ оруулна уу (5 эсвэл түүнээс дээш)', // to translate
    question: 'Асуултаа оруулна уу',
    start_date: 'Эхлэх өдөр & цаг шаардлагатай',
    tag: 'Тааг сонгоно уу',
    topics: 'Нэгээс доошгүй сэдэв сонгоно уу.',
    live_topics: ' Сэдвүүд нэмнэ үү',
    title: 'Гарчиг оруулна уу ',
    title_assessment: 'Үнэлгээний нэр оруулна уу',
    title_course: 'Курсийн нэр оруулна уу',
    title_maze: 'Мэйзийн нэр оруулна уу', // to translate
    title_empty: 'Нэр хоосон байж болохгүй',
    title_event: 'Эвентийн нэр оруулна уу',
    title_lesson: 'Хичээлийн нэр оруулна уу',
    title_quiz: 'Тааврын нэр оруулна уу',
    trainer_bio: 'Багшийн товч мэдээлэл оруулна уу', // to translate
    trainer_linkedin: 'Багшийн linkedin хаягийг оруулна уу', // to translate
    username: 'Хэрэглэгчийн нэрээ оруулна уу',
    upload_error: 'Алдаа – Файл тохирохгүй байна!',
    upload_more_than_10: 'Та нэг удаад 10-аас доош файл байршуулах боломжтой.',
    video: 'Видеоны тоог оруулна уу', // to translate
    video_link: 'Видеоны холбоос оруулна уу', // to translate
    topics_max: '5-аас дээшгүй сэдэв нэмнэ үү. (5-ын тоо)', // to translate  (just the digit 5)
    upload_excel: 'Зөв файл байршуулсан эсэхээ шалгана уу.',
    title_excel: 'Загварыг байршуулахад алдаа гарлаа:',
    file_size_exceed: 'Файлын хэмжээ ихэдсэн',
    subtitle_excel:
      'Өгсөн загварыг ашиглаж, багануудыг зөв бөглөсөн эсэхээ шалгана уу.',
    select_broadcast_option: 'Эвентийг өргөн нэвтрүүлэх сонголтоо хийнэ үү',
    multi_hosts_number_error: 'Илтгэгчийн тоо эвентэд зааснаас хэтрэх ёсгүй.',
    conference_people_number_error: `Оролцогчдын тоо эвентэд зааснаас хэтрэх ёсгүй.`,
    select_max_host: 'Эвентэд нэгээс доошгүй илтгэгч сонгоно уу.',
    select_max_conference: 'Эвентэд нэгээс доошгүй оролцогч сонгоно уу.',
    stream_stop_error: 'Дахин холбогдох гэж оролдож байна...',
    no_stream_error: 'зохион байгуулагч эвент эхлүүлэхийг хүлээж байна',
    unsecure_context:
      'Ноцтой алдаа: Аюултай контекстийн улмаас хөтөч камер, мик ашиглах боломжгүй байна. SSL суулгаад https хаягаар хандана уу',
    ws_not_supported:
      'Ноцтой алдаа: WebSocket-ыг энэ хөтөч дээр ашиглах боломжгүй.',

    // added_first
    no_org: 'Үргэлжлүүлэхийн тулд нэгээс доошгүй байгууллага сонгоно уу.', // to translate
    no_org_group:
      'Үргэлжлүүлэхийн тулд нэгээс доошгүй байгууллагын групп сонгоно уу.', // to translate
    waiting_to_join: 'Хүн нэгдэхийг хүлээж байна!', // to translate

    //new
    select_transcribe_locale: 'Хөрвүүлэх хэлээ сонгоно уу', // to translate
    transcribe_limit: 'Хөрвүүлэх минутаа оруулна уу', // to translate
    not_complete: 'Зах зээлийн мэдээлэл гүйцэд бус', // to translate
    complete: 'Зах зээлийн мэдээлэл бүрэн гүйцэд', // to translate
    not_admin: 'Зах зээлд нийтлэхийн тулд админы зөвшөөрөл хэрэгтэй', // to translate
    no_course: 'Зах зээлийг нээхийн тулд нэр өгөөд, зургаа сонгоно уу.', // to translate
    scorm_not_complete:
      'Скорм файл оруулахын тулд нэр өгөөд, зургаа сонгоно уу.', // to translate
    //maze
    not_found_maze: 'Мэйз олдсонгүй', // to translate
    email_require: 'Имэйл шаардлагатай', // to translate
    poll_required: 'Санал хураалтын дата шаардлагатай' // to translate
  },

  events: {
    title: 'Шууд эвентийн деталь нэмэх',
    change_host: 'Зохион байгуулагчийн өөрчлөх',
    finished: 'Эвент дууссан',
    countdown: 'Шууд эвент дамжуулах хүртэл хугацаа ',
    subtitle: 'Шууд эвентдээ нэр өгч, юуны тухай болохыг хүмүүст хэлнэ үү.',
    poll_disabled: 'Энэ эвентэд санал хураах боломжгүй.',
    disclaimer: `Миний эвентэд дараах зүйлсийг агуулаагүй гэдгийг баталж байна:
    - аливаа гуравдагч талын эрхийг зөрчөөгүй
  - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
  - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
  - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
  - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
  - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй'`,
    prompt_message:
      'Энэ хуудаснаа гарвал таны эвент дуусна. Та гарахдаа итгэлтэй байна уу?',
    duration_exceed_message:
      'Таны өргөн нэвтрүүлгийн хугацаа дууслаа. Апп өргөн нэвтрүүлгийг зогсоох болно.',
    before_schedule_message:
      'Та хуваарьт цагаас өмнө өргөн нэвтрүүлгийг эхлүүлэх гэж байна. Өргөн нэвтрүүлгийг зогсоовол эвент дуусна гэдгийг санана уу.',
    browser_unsupportive_message:
      'Уг хөтөч дээр дэлгэцээ хуваалцах боломжгүй байна. Энэ холбоосоор орж боломжтой хөтчүүдийг харна уу',
    cancel_switch_host_message:
      'Зохион байгуулагч байхгүй байна. Эвентийг та үргэлжлүүлэх болно.',
    coaching_prompt_message:
      'Эвент дуусах хүртэл та энэ хуудсыг орхих боломжгүй.',
    event_modal_warn: 'Та эвентээс гарахыг хүсэж байна уу?',
    event_end_warn: 'Та эвентийг дуусгамаар байна уу?',
    confirm_message: 'Та OK гэдгийг дарвал эвент дуусна.',
    screen_share_denied: 'Та дэлгэцээ хуваалцахаас татгалзсан',
    media_not_found:
      'Камер, мик олдсонгүй эсвэл таны төхөөрөмж дээр ашиглах зөвшөөрлийг өгөөгүй байна.',
    media_not_access:
      'Камер эсвэл микийг өөр хэсэгт ашиглаад, төхөөрөмж ашиглахыг зөвшөөрөхгүй байна',
    constraint_error:
      'Таны видео, аудионы шахалтад нийцэх төхөөрөмж олдсонгүй. Та видео, аудионыхоо шахалтыг өөрчилж болно.',
    media_access_denied: 'Камер, мик ашиглахыг зөвшөөрөөгүй байна.'
  },

  filters: {
    days7: 'Сүүлийн 7 өдөр',
    days15: 'Сүүлийн 15 өдөр',
    days30: 'Сүүлийн 30 өдөр',
    days365: 'Сүүлийн 365 өдөр',
    date: 'Үүсгэсэн огноо',
    relevance: 'Ач холбогдол',
    popularity: 'Түгээмэл байдал',
    name: 'Нэр',
    group: 'Групп',
    Newest_to_Oldest: 'Шинээс хуучин',
    Oldest_to_Newest: 'Хуучнаас шинэ',
    A_Z: 'А-аас Я',
    Z_A: 'Я-аас А'
  },

  helpers: {
    password:
      'Таны бүртгэлийн нууцлалыг хадгалахын тулд бид нэгээс доошгүй жижиг үсэг, тоо багтаахыг шаарддаг. Мөн та 10-аас доошгүй тэмдэгт бүхий нууц үг сонгох хэрэгтэй.',
    phone: 'Улсын кодоо оруулна уу. Жишээ нь: +65',
    username:
      'Хэрэглэгчийн нэр нь нийтийн мэдээлэл гэж тооцогдох ба шаардлагатай тохиолдолд бусад хэрэглэгчидтэй хуваалцана. Иймээс хувийн мэдээллээ хэрэглэгчийн нэрээр сонгохгүй байхгүй хүсэж байна.',
    public_description_normal:
      'Таны <0><0/></0> хадгалагдлаа. Анхны тохиргоо нь Хувийн байна. Энэхүү контентыг зөвхөн та харж болно гэсэн үг. Контентыг нийтлэхийг тулд та доорх сонголтуудаас аль нэгийг сонгоно. <0><0/></0>-ээ Нийтэд нээлттэй нийтлэнэ гэдэг нь платформ дээр бүх хэрэглэгчид харагдана гэсэн үг. Тодорхой хэрэглэгчид харагдах сонголтыг хийснээр та <0><0/></0>-ээ Sharelook-т бүртгэлтэй имэйл хаягийг ашиглан тодорхой хүмүүст харуулах юм.',
    public_description_admin:
      'Таны <0><0/></0> хадгалагдлаа. Анхны тохиргоо нь Хувийн байна. Ингэснээр зөвхөн та (контентыг хийсэн хүн) энэ контентыг харна. Контентыг нийтлэхийг тулд та доорх сонголтуудаас аль нэгийг сонгоно уу. <0><0/></0>-ээ Нийтэд нээлттэй нийтэлнэ гэдэг нь платформ дээр бүх хэрэглэгчид харагдана гэсэн үг. Үүнд танай байгууллагаас гаднах хүмүүс мөн хамаарна. Байгууллагадаа нийтэлнэ гэвэл зөвхөн танай байгууллага дахь хүмүүс уг контентыг харна. Мөн та 1 эсвэл түүнээс олон группэд нийтэлж болно. Энэ тохиолдолд зөвхөн тухайн группийн хүмүүс контентыг харна. Эцэст нь та Sharelook-т бүртгэлтэй имэйлийг ашиглан байгууллагын доторх болон гаднах тодорхой хүмүүст нийтлэх боломжтой.'
  },

  labels: {
    add: 'Нэмэх',
    no_of_people_in_conference: 'Хуралд хэчнээн хүн байна вэ?', //to translate
    portrait: 'Босоо зургийг тайрах',
    landscape: 'Хөндлөн зургийг тайрах',
    transcribe_settings: 'Хөрвүүлэх тохиргоо', // to translate
    transcribe: 'Хөрвүүлэх', // to translate
    answer_type: 'Хариултын төрөл',
    answers: 'Хариултууд',
    back_to_quiz: 'Тааврын жагсаалт руу буцах',
    back_to_question: 'Асуултын жагсаалт руу буцах',
    chat: 'Чат',
    chat_available: 'Энэ эвентэд чатлах боломжгүй',
    chat_report: 'Чат тайлан',
    choice_single: 'Дан сонголт',
    choice_multiple: 'Олон сонголт',
    choice_free: '"Үнэгүй" сонголт',
    choice_sorting: '"Эрэмбэлэх" сонголт',
    choice_matrix: '"Матрикс эрэмбэлэх" сонголт',
    clone_lesson_permission: 'Клон хийх зөвшөөрөл',
    code: 'Код',
    correct: 'Зөв',
    created: 'Үүсгэсэн огноо',
    clone_modal: 'Курсийг клон хийх',
    cloning_course: 'Курсийг клон хийж байна...',
    cloning_maze: 'Мэйзийг клон хийж байна...', //to translate
    cloning: 'Клон хийж байна...',
    cloning_course_desc:
      'Энэ процесс хугацаа шаардана. Та тэвчээртэй хүлээнэ үү',
    cloning_success: '"<0/>" курсийг амжилттай клон хийлээ!',
    maze_cloning_success: '"<0/>" мэйзийг амжилттай клон хийлээ!', // to translate
    create_certificate: 'Сертификат үүсгэх', // to translate
    create_badge: 'Тэмдэг үүсгэх', // to translate
    certificate_added: 'Сертификат нэмэгдлээ.', // to translate
    badge_added: 'Тэмдэг нэмэгдлээ.', // to translate
    certificate_warning:
      'Нийтлэгдсэний дараа сертификат/тэмдгийг засварлах боломжгүй!', // to translate
    description: 'Тайлбар',
    disclaimer: 'Үгүйсгэсэн мэдэгдэл',
    drop_file: 'Файлаа энд оруулна уу...',
    duration: 'Үргэлжлэх хугацаа',
    edit: 'Засварлах',
    email: 'Имэйл',
    event: 'Эвент',
    event_all: 'Түүний бүх эвентүүд',
    event_date: 'Шууд эвентийн орон нутгийн цагаар Огноо/Цаг',
    event_this: 'Энэ эвент',
    expire: 'Дуусах хугацаа',
    expiry_date: 'Дуусах өдөр',
    forgot: 'Нууц үгээ мартсан уу?',
    group: 'Групп',
    groups_list: 'Группүүдийн жагсаалт',
    host: 'Зохион байгуулагч',
    id_annotation: 'Тайлбарын id',
    id_number: 'Id дугаар', // to translate
    id_quiz: 'Тааврын id',
    incorrect: 'Буруу',
    interests: 'Сонирхол',
    invited: 'Урьсан',
    live_chat: 'Шууд хэлэлцүүлэг',
    live_stream_limit: 'Шууд дамжуулалтын минут',
    contact_text:
      'Шууд дамжуулалтын сарын хязгаараа өөрчлөхийг хүсвэл холбоо барина уу',
    contact_admin:
      '<0>Хэрэв та шууд дамжуулалтын сарын хязгаараа өөрчлөхийг хүсвэл</0> <1>admin@sharelook.com</1>хаягаар холбогдоно уу',
    limit_stream_text:
      'Шууд дамжуулалтын үлдсэн минут: <0>{{ limit }}</0> минут<1/><2/> <3> Шууд дамжуулалтын сарын хязгаараа өөрчлөхийг хүсвэл</3> <4>admin@sharelook.com</4>хаягаар холбогдоно уу',
    location: 'Байршил',
    lessons: 'Хичээлүүд',
    location_broadcast: 'Зохион байгуулагчийн серверийн байршил',
    location_broadcast_subtitle:
      'Дуу дүрсний саажилтыг бууруулахын тулд зохион байгуулагчийн байршилтай хамгийн ойр байршил нэмнэ үү',
    media_manager: 'Медиа менежер',
    minutes: 'Минут',
    name: 'Нэр',
    online_quiz: 'Цахим таавар',
    organiser: 'Зохиолч',
    organization: 'Байгууллага',
    overall_emotion: 'Ерөнхий туршлага:',
    organizations_list: 'Байгууллагуудын жагсаалт',
    password: 'Нууц үг',
    participants: 'Оролцогчид',
    pass_score: 'Босго оноо', // to translate
    picture: 'Зураг',
    scorm_zip: 'Скорм Zip', // to translate
    phone: 'Утас',
    photo: 'Гэрэл зураг',
    poll: 'Санал хураалт',
    position: 'Байрлал',
    processing: 'Дамжуулж байна',
    privacy_settings: 'Хувийн тохиргоо',
    question: 'Асуулт',
    quiz_create: 'Шинэ таавар үүсгэх',
    quiz_name: 'Тааврын нэр',
    quiz_update: 'Тааврыг шинэчлэх',
    select_organization: 'Байгууллага сонгох',
    settings: 'Тохиргоо',
    show: 'Харуулах',
    show_graph: 'Графикийн үр дүнг харуулах',
    signin: 'Нэвтрэх',
    signup: 'Бүртгүүлэх',
    sort_by: 'Эрэмбэлэх',
    start_date: 'Эхлэх өдөр',
    tags: 'Таагууд',
    terms: 'Би<1>үйлчилгээний нөхцөлийг</1>хүлээн зөвшөөрч байна.',
    timezone: 'Цагийн бүс', //to translate
    title: 'Гарчиг',
    topics: 'Сэдвүүд',
    topic: 'Сэдэв',
    total_comments: 'Нийт сэтгэгдэл',
    username: 'Хэрэглэгчийн нэр',
    users_list: 'Хэрэглэгчдийн жагсаалт',
    users_emails: `Тодорхой хэрэглэгчийн имэйл сонгоно уу`,
    description_specifiction_email:
      'Тодорхой олон хэрэглэгч рүү илгээхийн тулд мөр бүрт 1 имэйл хаяг оруулна уу.',
    message_specific_email: 'Тодорхой хэрэглэгчийн имэйлийг оруулна уу.',
    viewers: 'Харсан хүмүүс',
    edit_course: 'Засварлах',
    edit_assessment: 'Засварлах',
    edit_event: 'Засварлах',
    edit_maze: 'Засварлах', //to translate
    delete_course: 'Устгах',
    delete_event: 'Устгах',
    delete_maze: 'Устгах', //to translate
    delete_assessment: 'Устгах',
    view_course: 'Харах',
    view_event: 'Харах',
    view_assessment: 'Харах',
    view_maze: 'Харах', //to translate
    date_event: 'Шууд эвентийн өдөр',
    date_assessment: 'Шууд үнэлгээний өдөр',
    clone_of: 'Клон',
    clone_course:
      'Бүх хичээл хуудсыг багтаасан курсийн эхийг бие даан өөрчлөх боломжтой клон үүсгэх.',
    make: 'Нээлттэй болгох',
    available_to: 'бүх ShareLook хэрэглэгчдэд нээлттэй',
    uploaded_by: 'Байршуулсан хүн: ',
    course: 'Курс',
    assessment: 'Үнэлгээ',
    user_not_exist: 'Хэрэглэгч олдсонгүй. Та урилга илгээх үү?',
    check_user: 'Мэдэгдэл',
    user_not_exist_in_org:
      'Энэ байгууллагад ийм хэрэглэгч байхгүй байна. Та урилга илгээх үү?',
    title_modal_stream: 'Байгууллагын шууд дамжуулалтын хязгаарыг өөрчлөх',
    des_warning_stream: 'Та өөрчлөх гэж байна',
    monthly_stream: 'cарын шууд дамжуулалтын хязгаар:',
    min_per_month: 'минут/цаг',
    broadcast_label: 'Би үүнийг хүсэж байна:',
    hosts_emails: `Тодорхой зохион байгуулагчийн имэйлийг оруулах`,
    attendee_emails: `Тодорхой оролцогчийн имэйлийг оруулах`,
    examinee_emails: `Тодорхой шалгуулагчийн имэйлийг оруулах`, // to translate
    description_host_specifiction_email: 'Мөр бүрд нэг имэйл хаяг оруулна уу.',
    presenter_label: 'Илтгэгч',
    presenter_label_conference: 'Хүний тоо',
    event_privacy: 'Хурлын горим',
    // added_second
    alert: 'Анхааруулга!', // to translate
    warning: 'Анхаар!', // to translate
    ok: 'За', // to translate
    cancel: 'Цуцлах', // to translate
    done: 'Болсон', // to translate
    insert: 'Оруулах', // to translate
    private: 'Хувийн', // to translate
    public: 'Нийтийн', // to translate
    no_connection: 'Интернэт холболт салсан', // to translate
    switch: 'Солих', // to translate
    share_screen: 'Дэлгэц хуваалцах', // to translate
    stop_share_screen: 'Дэлгэц хуваалцахаа болих', // to translate
    share_screen_with_camera: 'Камертай дэлгэц хуваалцах', // to translate
    stop_share_screen_with_camera: 'Камертай дэлгэц хуваалцахаа болих', // to translate
    camera_on: 'Камер асаалттай', // to translate
    camera_off: 'Камер унтраасан', // to translate
    mic_on: 'дууг нээх', // to translate
    mic_off: 'дууг хаах', // to translate
    fullscreen: 'бүтэн дэлгэц', // to translate
    live_now: 'Шууд дамжуулж байна', // to translate
    schedule_on: 'Хуваарьт өдөр', // to translate
    organisations: 'Байгууллагууд', // to translate
    org_groups: 'Байгууллагын группүүд', // to translate
    specific_user: 'Тодорхой хэрэглэгч', // to translate
    gif: 'GIF', // to translate
    unavailable: 'байхгүй байна', // to translate
    yes: 'Тийм', // to translate
    no: 'Үгүй', // to translate
    event_duration_message: '300 минутаас дээшгүй(5 цаг)', // to translate
    send_email: 'Имэйл мэдэгдэл илгээх', // to translate
    admin_only: 'Зөвхөн админ', // to translate
    join: 'Нэгдэх', // to translate
    leave: 'Орхих', // to translate
    share: 'Хуваалцах', // to translate
    share_text: 'Энэ файлыг хуваалцах хүнийхээ имэйлийг бичнэ үү', // to translate
    share_text_title: 'PDF хуваалцах', // to translate
    share_text_title_txt: 'Текст хуваалцах', // to translate
    select_users: 'Хэрэглэгчид сонгох', // to translate
    delete: 'Хэрэглэгчид сонгох', // to translate
    attachment_event: 'Эвентийн хавсралтууд:', // to translate,
    // newly added
    transcribe_limit: 'Хөрвүүлэх минут', // to translate
    monthly_transcribe: 'сарын хөрвүүлэх хязгаар:', // to translate
    enable_ai: 'Хиймэл оюун ухааныг идэвхжүүлэх:', // to translate
    media_service: 'Медиа үйлчилгээ', // to translate
    allow_others: 'Бусад хүмүүс засвар хийхийг зөвшөөрөх' // to translate
  },

  broadcastOptions: {
    stream_from_phone: ' Утсаараа шууд өргөн нэвтрүүлэх',
    other_webrtc: 'Хувийн компьютероосоо веминар хийх',
    multihost: 'Хувийн компьютероосоо олон хэрэглэгчид рүү веминар хийх',
    peer2peer: 'Дасгалжуулалтын уулзалт',
    conference: 'Шууд хурал'
  },

  //to translate
  conferenceTeamOptions: {
    uptoTen: '1-ээс 10', // to translate
    uptoTwenty: '11-ээс 20', // to translate
    uptoTwentyFive: '21-ээс 25' // to translate
    // uptoForty: '31 to 40'
  },

  //to translate
  conferenceAttendeeOptions: {
    uptoTwoHundredFifty: '1-ээс 250' // to translate
    // uptoHundred: '51 to 100',
    // uptoTwoHundred: '101 to 200'
    // uptoForty: '31 to 40'
  },

  mediaServices: {
    ANTMEDIA: 'АНТМЕДИА', // to translate
    CHIME: 'ЧАЙМ' // to translate
  },

  lessoncreate: {
    title: 'Хичээлийн дэлгэрэнгүй нэмэх',
    subtitle: 'Хичээлдээ нэр өгөөд, юун тухай болохыг хүмүүст хэлнэ үү.',
    input_label_title: 'Хичээлийн нэр',
    input_label_topics: 'Хичээлийн сэдвүүд',
    input_label_description: 'Хичээлийн тайлбар',
    delete_warning: 'Та энэ хуудсыг устгахдаа итгэлтэй байна уу?'
  },

  lessonoverview: {
    title: 'Хичээл нэмэх',
    subtitle: 'Add existing lesson or create a new one',
    new_lesson: 'create a new lesson',
    new_lesson_sub: 'Бэлэн хичээл нэмэх эсвэл шинийг үүсгэх!',
    existing_lesson: 'Шинэ хичээл үүсгэх',
    existing_lesson_sub:
      'Бэлэн хичээлтэй холбох, энэ хичээлд хийсэн өөрчлөлт нь бусад курсэд байгаа энэ хичээлд л нөлөөлнө.',
    clone_lesson: 'бэлэн хичээлийг хуулбарлах',
    clone_lesson_sub:
      'Хичээлийн цор ганц хуулбар үүсгэх. Энэ хичээлд оруулсан өөрчлөлт эх хичээлд нөлөөлөхгүй.',
    clone_lesson_modal_sub:
      'Курсдээ нэмэх хичээлийнхээ доорх клон товчийг дарна уу.'
  },

  management: {
    groups_title: 'Группүүдээ удирдах',
    delete_warning: 'Та итгэлтэй байна уу?',
    organizations_title: 'Миний байгууллагууд',
    organizations_subtitle: 'Жагсаалтдаа байгууллагууд нэмэх',
    users_title: 'Хэрэглэгчдийг удирдах',
    users_position: 'Бүртгэл хариуцсан ахлах менежер',
    user_not_found: 'Хэрэглэгч олдсонгүй',
    select_org: 'Хэрэглэгчдийг удирдахын тулд байгууллага олоод сонгоно уу',
    select_org_report: 'Тайлан гаргахын тулд байгууллага олоод сонгоно уу' // to translate
  },

  audio: {
    modal_title: 'Аудио оруулах',
    list_view: 'Жагсаалтаар харах',
    create_audio_modal_title: 'Аудио үүсгэх',
    edit_audio_modal_title: 'Аудио засварлах',
    public_audio_not_found: 'Аудио олдсонгүй.',
    private_audio_not_found: 'Та хараахан аудио байршуулаагүй байна',
    org_audio_not_found: 'Аудио олдсонгүй.', // to translate
    are_you_sure_to_delete: 'Та устгахдаа итгэлтэй байна уу?',
    type_something: 'Ямар нэг зүйл шивэх',
    select_voice: 'Сонгох',
    file_name: 'Файлын нэр',
    description: 'Тайлбар',
    topic: 'Сэдэв',
    key_words_tag: 'Түлхүүр үгийн тааг',
    mp3_audio: 'MP3 аудио',
    created: 'Үүсгэсэн',
    duration: 'Үргэлжлэх хугацаа',
    close: 'хаах'
  },

  image: {
    modal_title: 'Зураг оруулах',
    image: 'Зураг',
    pixel: 'Нягтрал',
    dimension: 'Хэмжээ',
    public_image_not_found: 'Зураг олдсонгүй.',
    private_image_not_found: 'Та хараахан зураг байршуулаагүй байна',
    org_image_not_found: 'Зураг олдсонгүй.' // to translate
  },

  annotation: {
    modal_title: 'Тайлбар'
  },

  text: {
    modal_title: 'Текст засварлагч',
    insert_text: 'Текст оруулах', // to translate
    insert_question_answer: 'Асуулт хариулт хиймэл оюун ухаан', //to translate
    modal_title2: 'Текст галерей', // to translate
    my_text_library: 'Миний текст галерей', // to translate
    ai: 'Хиймэл оюун ухаан', // to translate
    public_text_library: 'Нийтийн текст галерей', // to translate
    organization_text_library: 'Байгууллагын текст сан', // to translate
    no_transcribed_text: 'Хөрвүүлсэн текст олдсонгүй', // to translate
    public_text_not_found: 'Нийтийн хөрвүүлсэн текст олдсонгүй.', // to translate
    org_text_not_found: 'Байгууллагын хөрвүүлсэн текст олдсонгүй.' // to translate
  },

  video: {
    modal_title: 'Видео оруулах',
    image: 'Видео',
    mp4_video: 'MP4 Видео',
    public_video_not_found: 'Видео олдсонгүй.',
    private_video_not_found: 'Та хараахан видео байршуулаагүй байна',
    org_video_not_found: 'Видео олдсонгүй.' // to translate
  },

  media: {
    title: 'Медиа сан',
    subtitle: 'Таны файлуудын сан',
    modal_title: 'Медиа байршуулах',
    canva: 'Canva-аас үүнийг хийх', // to translate
    canva_open: 'Canva Editor нээх бол энд дар', //to translate
    delete_warning: 'Устгахаа баталгаажуулах',
    delete_message:
      'Устгагдсан медиа нь ашиглагдсан хуудаснууд дээрээ харагдсаар байх болно',
    dropzone_text: 'Эсвэл чирээд авчрах',
    delete_success: 'Медиа амжилттай устлаа',
    upload_file: 'Файл байршуулах',
    drag_drop: 'эсвэл чирээд авчрах',
    import_file: 'Компьютероосоо файл(ууд) импорт хийх',
    no_media: 'Та хараахан медиа байршуулаагүй байна',
    media_type: 'Медиа төрөл',
    video: 'Видео',
    image: 'Зураг',
    audio: 'Аудио',
    gif: 'GIF',
    pdf: 'PDF', // to translate
    transcribed_text: 'Хөрвүүлсэн текст',
    txt: 'ТЕКСТ', // to translate
    media_not_found: 'Медиа олдсонгүй.',
    of: '-ын',
    disclaimer: `Миний медиа дараах зүйлсийг зөрчөөгүй гэдгийг баталж байна:

    - аливаа гуравдагч талын эрхийг зөрчөөгүй
    - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
    - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
    - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
    - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
    - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй`,

    // added_first
    my_media: 'Миний медиа', // to translate
    maze_scenes: 'Мэйз үзэгдлүүд', // to translate
    public_library: 'Нийтийн сан', // to translate
    organization_library: 'Байгууллагын сан', // to translate
    upload_from_computer: 'Компьютероос байршуулах', // to translate
    pexel_images: 'Pexel зургууд', // to translate
    create: 'Үүсгэх', // to translate
    all: 'Бүгд', // to translate
    male: 'Эрэгтэй', // to translate
    female: 'Эмэгтэй', // to translate
    processing_audio: 'Аудиог боловсруулж байна', // to translate
    create_annotation: 'Тайлбар үүсгэх', // to translate
    popup_over_lesson_text:
      'Дарсны дараа хичээлийн хуудас дээр тайлбар үсэрч гарч ирнэ', // to translate
    edit_detail: 'Деталь засварлах', // to translate
    delete: 'Устгах', // to translate
    go_create_audio: 'Аудио үүсгэх рүү очих', // to translate
    show_more_details: 'илүү деталь харуулах', // to translate
    show_less_details: 'бага деталь харуулах', // to translate
    drop_files: 'Файлаа оруулаад, байршуулах газар', // to translate
    or: 'Эсвэл', // to translate
    import_files: 'Компьютероос файлууд импорт хийх', // to translate
    // added_fourth
    human: 'Премиум', // to translate
    shared_file: 'Та файлаа амжилттай хуваалцлаа', // to translate
    error_shared_file: 'Файл хуваалцахад алдаа гарлаа. Дахин оролдоно уу.', // to translate
    publish: 'Нийтлэх' // to translate
  },

  navigation: {
    account: 'Бүртгэл',
    assessments: 'Үнэлгээнүүд',
    dashboard: 'Талбар',
    groups: 'Групп менежмент',
    logout: 'Гарах',
    organisations: 'Байгууллагууд',
    organizations_users: 'Байгууллагууд & Хэрэглэгчид',
    reports: 'Тайлангууд',
    schedule: 'Хуваарь',
    training: 'Сургалт',
    users: 'Хэрэглэгчид',

    // added_first
    nowLive: 'Шууд',

    workshop: 'Миний дасгал ажил'
  },

  onboarding: {
    step1_title: 'Алхам 1 : Бидэнд өөрийнхөө тухай товч танилцуулах',
    step1_subtitle:
      'Таны нэр хэн бэ? Та хаанаас ирсэн бэ? Таны албан тушаал юу вэ?',
    step2_title: 'Алхам 2 : Сайжруулах шаардлагатай зарим ур чадвар',
    step2_subtitle:
      'Дараа нь юуг илүү ойлгохыг хүсэж буй тухайгаа хэлнэ үү. Сайн ойлгохгүй байгаа зүйл байж болно. Шинэ зүйлийн талаар сурах гэж байна уу? Таны хайртай хүн юу хийдэг вэ?'
  },

  pagebuilder: {
    title: 'Хичээл үүсгэх',
    subtitle:
      'Танаас хүмүүс сурах контентыг үүсгэх цаг боллоо. Та зураг, видео, инфографик ашиглаж болно',
    select_layout: 'Хуудасны төлөвлөлтийг сонгох',
    template1: 'Хоосон',
    template2: 'Гарчиг & Дэд гарчиг',
    template3: 'Гарчиг & Текст',
    template4: 'Гарчиг, Медиа & Текст',
    template5: 'Гарчиг & Медиа',
    template6: 'Гарчиг & Таавар'
  },

  pageconstructor: {
    title: 'Хичээл үүсгэх болон клон хийх',
    subtitle:
      'Танаас хүмүүс сурах курсийн контентыг үүсгэх цаг боллоо. Та зураг, видео, инфографик ашиглаж болно'
  },

  passwordreset: {
    success_coded:
      'Таны өгсөн хаяг руу баталгаажуулах код имэйлээр илгээсэн. Доорх хэсэгт тухайн кодыг хуулаад шинэ нууц үг үүсгэнэ үү.',
    success_changed:
      'Та шинэ нууц үг амжилттай үүсгэлээ. Та одоо нэвтэрч болно.'
  },

  placeholders: {
    attempts_count: 'Хэрэглэгч дахин оролдох боломжтой тоо', // to translate
    no_of_people_placeholder: 'Number of people', //to translate
    search: 'Хүмүүсийн тоо',
    answer: 'Хайх',
    chat: 'Ямар нэг зүйл хэлэх...',
    code: 'Код',
    criterion: 'Шалгуур',
    date_event: 'Өдөр & цаг сонгох',
    date_start: 'Эхлэх огноо',
    date_expire: 'Дуусах огноо',
    description: 'Тайлбар',
    elements: 'Элементүүдийг эрэмбэлэх',
    email: 'Имэйл',
    feedback_correct: 'Санал зөвлөмж зөв',
    feedback_incorrect: 'Санал зөвлөмж буруу',
    host: 'Зохион байгуулагч',
    keywords: 'Түлхүүр үг(с) хайх',
    lesson_description: 'Хичээлийн тайлбар',
    location: 'Байршил',
    minutes: 'Минут',
    name: 'Нэр',
    organiser: 'Зохиолч',
    organization: 'Байгууллага',
    password: 'Нууц үг',
    phone: 'Утас',
    photo: 'Зураг',
    picture: 'Зураг',
    point: 'Оноо',
    position: 'Байрлал',
    question: 'Асуулт',
    quiz: 'Тааврын нэр',
    search_course: 'Курсээр хайх',
    search_media: 'Медиагаар хайх',
    search_name: 'Нэрээр хайх',
    search_title: 'Гарчгаар хайх',
    search_training: 'Сургалтаар хайх',
    settings: 'Тохиргоо',
    tags: 'Таагууд',
    title: 'Гарчиг',
    topics: 'Сэдвүүд',
    username: 'Хэрэглэгчийн нэр',
    keyword: 'Түлхүүр үгс',
    max_500_characters: '500 тэмдэгтээс дээшгүй',
    no_description: 'Файлд тайлбар алга',
    no_keyword: 'Файлд түлхүүр үгс алга',
    no_topics: 'Файлд сэдэв тохируулаагүй байна',
    feedback: 'Мессеж',
    contact: 'Бид яаж туслах вэ?',
    text: ' Текстээ энд бичнэ үү.' //to translate
  },

  publishsettings: {
    title: 'Нийтлэх тохиргоо',
    event_subtitle:
      'Эвентээ тохиргоо хийнэ үү. Эвентийг хэн харах, харьцаж болохыг тохируулна',
    assessment_subtitile:
      'Үнэлгээндээ нэр өгөөд үүнээс юу сурах тухай хүмүүст хэлж өгнө үү',
    course_subtitle:
      'Курсдээ тохиргоо хийнэ үү. Курсийг хэн харах, харьцаж болохыг тохируулна',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: 'Хоёр огноог хоёуланг бөглөнө.',
    emails_validation_error: 'Имэйл жагсаалт буруу байна.',
    specific_email_validation_error: 'Зөвхөн нэг имэйл зөвшөөрнө.',
    i_agree_to_these: 'Бид эдгээр',
    terms_and_conditions: 'үйлчилгээний нөхцөлийг зөвшөөрч байна.',
    PublicDescription:
      'Үнэгүй ашиглах хувь хэрэглэгчид: (Хувийн болон нийтийн сонголт) Таны [Курс|Эвент|Үнэлгээ] хадгалагдан, анхны тохиргоогоор Хувийн байна. Энэ контент зөвхөн танд харагдана гэсэн үг. Контентыг нийтлэхийн тулд доор зааснаар нийтийн болгоно уу. Ингэвэл платформ дээр бүх хэрэглэгчид курс харагдана.',
    OrganisationsDescription:
      'Байгууллагын хэрэглэгчид: (""Дуусгах"" гэхийн оронд ""Нийтлэх"" гэдгийг дарж, өөр нийтлэх сонголт хийлгүйгээр бусад хэрэглэгчдийн адил хуудсыг нийтлээрэй.) Таны [Курс|Эвент|Үнэлгээ] хадгалагдсан ба Хувийн тохиргоотой байна. Зөвхөн та болон байгууллагын удирдлагууд харж болно гэсэн үг. Хэрэглэгч болохоор та байгууллагадаа контентыг нийтлэх боломжгүй ба удирдлагын зөвшөөрөл шаардлагатай. Удирдлагын хүнтэй холбогдож, контентыг нийтэд, байгууллагын бүх хүмүүст, байгууллагын тодорхой хэрэглэгчдэд өгөхийг хүснэ үү.',
    OrganisationGroupsDescription:
      'Байгууллагын удирдлага: (Байгууллага доторх контент: Хувийн, нийтийн, байгууллагын, группүүд, тодорхой хэрэглэгчид): Энэхүү [Курс|Эвент|Үнэлгээ] хадгалагдсан ба анхны тохиргоогоор Хувийн байна. Энэ нь зөвхөн танд (болон контент үүсгэгчид) харагдана гэсэн үг. Контентыг нийтлэх бол доорх сонголтуудаас хийнэ үү. Нийтэд курсээ нийтэлснээр платформ дээр бүх хэрэглэгчид харагдана гэсэн үг. Үүнд таны байгууллагад үл хамаарах хүмүүс ч багтана. Байгууллагад нийтлэх гэвэл байгууллагын бүх хүмүүс харна гэсэн үг. Мөн та нэг эсвэл түүнээс дээш тооны группэд нийтлэх боломжтой. Тухайн группэд байгаа хэрэглэгчид уг контентыг харна. Эцэст нь та байгууллагад үл хамаарах хүмүүст Sharelook-д бүртгэлтэй имэйлийг ашиглан тодорхой хэрэглэгчид нийтэлж болно.',
    SpecificUsersDescription:
      'Төлбөртэй хувь хэрэглэгчид: (хувийн, нийтийн, тодорхой хэрэглэгчид) Таны [Курс|Эвент|Үнэлгээ] хадгалагдсан ба анхны тохиргоогоор Хувийн байна. Энэ контент зөвхөн танд харагдана гэсэн үг. Контентыг нийтлэх бол дараах сонголтуудаас хийнэ үү. Курсийг нийтэд нийтэлвэл платформ дээр бүх хэрэглэгчид харагдана. Тодорхой хэрэглэгчид харуулах сонголтыг хийснээр та Sharelook-т бүртгэлтэй имэйл хаягийг ашиглан тодорхой хэрэглэгчдэд курсээ хуваалцах боломжтой.'
  },

  quiz: {
    quiz_empty: 'Та хараахан таавар үүсгээгүй байна',
    questions_empty: 'Та хараахан асуулт үүсгээгүй байна'
  },

  regions: {
    asia_pacific_australia: 'Австрали',
    asia_pacific_india: 'Энэтхэг',
    asia_pacific_japan: 'Япон',
    asia_pacific_s_korea: 'Өмнөд Солонгос',
    asia_pacific_singapore: 'Сингапур',
    asia_pacific_taiwan: 'Тайвань',
    eu_belgium: 'Бельги',
    eu_germany: 'Герман',
    eu_ireland: 'Ирланд',
    south_america_brazil: 'Бразил',
    us_central_iowa: 'Йова',
    us_east_s_carolina: 'Өмнөд Каролина',
    us_east_virginia: 'Виржиниа',
    us_west_california: 'Калифорниа',
    us_west_oregon: 'Орегон'
  },

  publishmaze: {
    title: 'Нийтлэх тохиргоо', // to translate
    maze_subtitle:
      'Мэйздээ тохиргоо нэмээрэй. Хэн таны мэйзийг харах, харьцаж болохыг тохируулаарай.', // to translate
    disclaimer: `Миний үнэлгээ дараах зүйлсийг зөрчөөгүй гэдгийг баталж байна:
    - аливаа гуравдагч талын эрхийг зөрчөөгүй
    - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
    - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
    - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
    - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
    - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй'` // to translate
  },

  reports: {
    title: 'Тайлангууд',

    // added_first
    workshop_report: 'Дасгал ажлын тайлан',
    user_report: 'Хэрэглэгчийн тайлан',
    organization_workshop: 'Байгууллагын дасгал ажил',
    course: 'Курс',
    live_event: 'Шууд эвент',
    workShop_graph: 'Дасгал ажлын график',
    organization_account: 'Байгууллагын бүртгэл',
    all: 'Бүх',
    name: 'Нэр',
    group: 'Групп', //to translate
    group_name: 'Группийн нэр', //to translate
    select_group: 'Групп сонгох', //to translate
    id_number: 'ID дугаар',
    email: 'Имэйл',
    search_user_report: 'Хэрэглэгчийн тайлангаар хайх',
    participant: 'Оролцогч',
    participants: 'Оролцогчид',
    host: 'Зохион байгуулагч',
    hosts: 'Зохион байгуулагчид', //to translate
    username: 'Хэрэглэгчийн нэр',
    event: 'Эвент',
    quiz: 'Таавар',
    assessment: 'Үнэлгээ',
    time: 'Хугацаа',
    no_recent_activity: 'Сүүлийн үед үйлдэл бүртгэгдээгүй байна',
    workshops: 'Дасгал ажлууд',
    courses: 'Курсүүд',
    live_events: 'Шууд эвентүүд',
    live_assessments: 'Шууд үнэлгээнүүд',
    quizzes: 'Тааврууд',
    overview: 'Тойм',
    by: '-аар',
    views: 'Үзсэн тоо',
    status: 'Статус',
    pass_score: 'Босго оноо', // to translate
    poll: 'Санал хураалт',
    comment: 'Сэтгэгдэл',
    comments: 'Сэтгэгдлүүд',
    no_comments: 'Сэтгэгдэл байхгүй',
    no_polls: 'Санал хураалт байхгүй',
    live_date: 'Шууд дамжуулах өдөр',
    score: 'Оноо',
    question: 'Асуулт',
    submit: 'Илгээх',
    recent_activity: 'Сүүлийн үеийн үйлдэл',
    ago: 'Өмнө',
    no_data_found: 'Дата олдсонгүй',
    start_end_live: 'Шууд дамжуулалтыг эхлүүлэх/Дуусгах',
    join_leave_date: 'Нэгдэх / Орхих',
    watched_time: 'Үзсэн хугацаа',
    complete: 'Гүйцэд',
    in_complete: 'Гүйцэд бус',
    today: 'Өнөөдөр',
    seven_days: '7 өдөр',
    last_month: 'Өнгөрсөн сар',
    one_year: '1 жил',
    all_time: 'Бүх хугацаа',
    report: 'Тайлан',
    from_date: 'Эхлэх огноо',
    to_date: 'Дуусах огноо',
    all_workshop: 'Бүх дасгал ажил',
    all_participants: 'Бүх оролцогчид',
    live_assessment: 'Шууд үнэлгээ',
    users: 'Хэрэглэгчид',
    download: 'Татах',
    recent: 'Саяхны',
    WorkShop: 'Дасгал ажил',
    Activity: 'Үйлдэл',
    created_date: 'Үүсгэсэн огноо',
    lessons: 'Хичээлүүд',
    lesson: 'Хичээл',
    report_download: 'ТАТАХ',
    this_month: 'Энэ сар',
    search_course: 'Курс хайх',
    // search_skill_journey: "Search Skill journey", // to translate
    search_maze: 'Мэйз хайх', // to translate
    participants_graph: 'Оролцогчдын график',
    viewed: 'Харсан',
    enrolled: 'Элссэн',
    description: 'Тайлбар',
    topic: 'Сэдэв',
    analytic: 'Анализ',
    quiz_list: 'Тааврын жагсаалт',
    select_one: 'Нэгийг сонгох',
    group_status: 'Групп статус',
    duration_min: 'Үргэлжлэх хугацаа (мин)',
    submit_poll: 'Санал хураалт илгээх',
    download_events: 'Эвентүүдийг татаж авах',
    search_event: 'Эвент хайх',
    duration: 'Үргэлжлэх хугацаа',
    total_participants: 'Нийт оролцогчид',
    message: 'Мессеж',
    avg_message: 'Дундаж мессеж',
    per_message: 'МЕССЕЖНИЙ ХУВЬ/ ЭВЕНТ',
    avg_score: 'Дундаж оноо', // to translate
    maze: 'Мэйз', // to translate
    maze_report: ' Мэйз тайлан', // to translate
    maze_view: 'Мэйз харагдах байдал', // to translate
    title_maze: 'Мэйз', // to translate
    author: 'Зохиогч', // to translate
    completed: 'Дуусгасан', // to translate
    match: 'Зам таарч байна', // to translate
    preview_mazeTitle: 'Гарчиг: ', // to translate
    other: 'Бусад', // to translate
    total: 'НИЙТ', // to translate
    report_courses: 'КУРСҮҮД', // to translate
    report_events: 'ЭВЕНТҮҮД', // to translate
    report_maze: 'МЭЙЗ', // to translate
    report_personalize_learning: 'СУРГАЛТЫГ ӨӨРТӨӨ ТОХИРУУЛАХ', // to translate
    report_live_assessments: 'ШУУД ҮНЭЛГЭЭНҮҮД', // to translate
    report_skill_journey: 'УР ЧАДВАРЫН АЯЛАЛ', // to translate
    skill_journey: 'Ур чадварын аялал', // to translate
    skill_journeys: 'Ур чадварын аяллууд', // to translate
    date: 'ОГНОО: ', // to translate
    search_people: 'Хүмүүс хайх', // to translate
    passed: 'ДАВСАН', // to translate
    failed: 'УНАСАН', // to translate
    item: 'ЗҮЙЛ', // to translate
    items: 'ЗҮЙЛС', //to translate
    type: 'ТӨРӨЛ', // to translate
    minimum_pass_score: 'БОСГО ОНОО', // to translate
    resources_count: 'ЭХ СУРВАЛЖИЙН ТОО', // to translate
    back: 'БУЦАХ', // to translate
    resources: 'ЭХ СУРВАЛЖУУД', // to translate
    time_spent: 'ЗАРЦУУЛСАН ХУГАЦАА (МИН)', // to translate
    detail: 'ДЕТАЛЬ', // to translate
    watched_time_mins: 'ҮЗСЭН ХУГАЦАА (МИН)', // to translate
    personalize_learning: 'сургалтыг өөртөө тохируулах', // to translate
    result: 'үр дүн', // to translate
    assessment_title: 'Гарчиг' // to translate
  },

  signup: {
    success_step1:
      ' Таны өгсөн хаяг руу баталгаажуулах код имэйлээр илгээсэн. Доорх хэсэгт тухайн кодыг хуулаад шинэ нууц үг үүсгэнэ үү.',
    success_step2: 'Баярлалаа. Таны бүртгэл амжилттай.',
    privacy: `Би Sharelook-ын <1> үйлчилгээний нөхцөл</1> болон <3> нууцлалын бодлогыг</3> хүлээн зөвшөөрч байна,`
  },

  stream: {
    emotion_impressive: 'Сэтгэл хөдөлгөм',
    emotion_unimpressive: 'Сэтгэл үл хөдөлгөм',
    message_not_started: 'Тун удахгүй',
    message_running: 'Шууд',
    message_processing:
      'Бид шууд бичлэгийн дахин тоглуулахаар боловсруулж байна. Дараа эргэн ирж видеог үзэж, үнэлгээ, санал зөвлөмжөө нэмээрэй.'
  },

  tabs: {
    audience: 'Үзэгчид',
    course: 'Курсийн тойм',
    details: 'Шууд эвентийн деталь',
    description: 'Тайлбар',
    host: 'Зохион байгуулагч',
    lesson: 'Хичээлийн тойм',
    lessons: 'Хичээлүүд',
    overview: 'Тойм',
    page: 'Хуудас үүсгэгч',
    publish: 'Нийтлэх',
    settings: 'Нийтлэх тохиргоо',
    total_views: 'Нийт үзсэн тоо',
    live_participates: 'Шууд дамжуулалтад оролцогчид',
    live_chats: 'Шууд чатууд',
    live_quiz: 'Шууд санал хураалтууд',
    trainer_rating: 'Багшийн үнэлгээ',
    trainer_times: 'Багшийн хугацаа',
    courses_quizzes: 'Курсийн таавар',
    user_list: 'Хэрэглэгчийн жагсаалт',
    discussion: 'Хэлэлцүүлэг',
    notes: 'Миний тэмдэглэлүүд',
    attachments: 'Нэмэлт хавсралт' // to translate
  },

  topics: {
    SALES_TRAINING: 'Борлуулалтын сургалт',
    NEGOTIATION_TRAINING: 'Хэлэлцээрийн сургалт ',
    CROSS_CULTURAL_AWARENESS: 'Соёлын хоорондын ялгаатай ойлголтыг таниулах',
    NETWORKING_SKILLS: 'Нэтворкинг ур чадвар',
    SOFTWARE_ARCHITECTURE: 'Программ хангамжийн архитектур',
    PROJECT_MANAGEMENT: 'Төслийн менежмент',
    DIGITAL_TRANSFORMATION: 'Цахим хувьсал',
    IT_CONSULTING: 'IT Зөвлөгөө',
    MANAGEMENT_CONSULTING: 'Менежмент зөвлөгөө',
    HR_CONSULTING: 'Хүний нөөцийн зөвлөгөө',
    INTERNET_OF_THINGS: 'Интернэтийн зүйлс (IoT)',
    CYBERSECURITY: 'Цахим аюулгүй байдал',
    PRIVACY_AND_GDRP: 'Хувийн болон Ерөнхий Дата Хамгаалах Тогтоомж'
  },

  training: {
    title: 'Сургалт',
    title_assessment: 'Үнэлгээнүүд',
    subtitle: 'Курсүүд болон шууд эвентүүд',
    enrolled_title: 'Элссэн курсүүд болон шууд эвентүүд',
    enrolled_subtitle: 'Таны элссэн курсүүд болон шууд эвентүүд',
    enrolled_message: 'Танд элссэн курс, эвент байхгүй байна.',
    maze_channel: 'Миний мэйз суваг', // to translate
    past_live_assessment: 'Өмнөх шууд үнэлгээнүүд', // to translate
    no_live_assessment: 'Шууд үнэлгээ одоогоор байхгүй байна', // to translate
    past_live_event_title: 'Өмнөх шууд эвентүүд',
    past_live_event_subTitle: 'Дууссан шууд эвентүүд',
    past_live_event: 'Өмнөх шууд эвент байхгүй байна.',
    recomended_title: 'Санал болгох курс, шууд эвентүүд',
    now_live_event_title: 'Одоо шууд дамжуулж байна',
    now_live_event_subTitle:
      'Шууд дамжуулж буй эсвэл удахгүй шууд дамжуулах эвентүүд',
    now_live_event: 'Шууд эвент одоогоор байхгүй байна.',
    no_maze: 'Мэйз байхгүй байна.', // to translate
    webinar_event_title: 'Вебинарын суваг',
    webinar_event_subTitle: 'Дууссан вебинарууд',
    webinar_event: 'Вебинар одоогоор байхгүй байна.',
    p2p_event_title: 'Дасгалжуулалтын уулзалтууд',
    p2p_event_subTitle: 'Дууссан дасгалжуулалтын уулзалтууд',
    p2p_event: 'Дасгалжуулалтын уулзалт одоогоор байхгүй байна.',
    // new translate
    conference_event_title: 'Хурлын эвентүүд', // to translate
    conference_event_subTitle: 'Дууссан хурлын эвентүүд', // to translate
    conference_event: 'Хурлын эвент одоогоор байхгүй байна.', // to translate
    skill_journey: 'Ур чадварын аялал', // to translate
    no_skill: 'Ур чадварын аялал одоогоор байхгүй байна', // to translate

    now_live_assessment_title: 'Одоо шууд дамжуулж байна',
    now_live_assessment_subTitle:
      'Шууд дамжуулж буй эсвэл удахгүй шууд дамжуулах үнэлгээнүүд',
    now_live_assessment_message: 'Шууд үнэлгээ одоогоор байхгүй байна',

    upcoming_assessment_title: 'Удахгүй болох шууд үнэлгээнүүд',
    upcoming_assessment_subtitle: 'Удахгүй болох шууд үнэлгээнүүд',
    upcoming_assessment_message: 'Шууд үнэлгээ одоогоор байхгүй байна.',

    past_live_assessment_title: 'Өмнөх шууд үнэлгээнүүд',
    past_live_assessment_subTitle: 'Дууссан шууд үнэлгээнүүд',
    past_live_assessment_message: 'Өмнөх шууд үнэлгээ байхгүй байна.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Таны <0><0/></0> дээр тулгуурлан курс, шууд эвентүүдийг санал болгож байна',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Сургалт хайх',
    search_assessment: 'Үнэлгээ хайх',
    recomended_message: 'Санал болгох курс, эвент одоогоор байхгүй.',
    search_user: 'Компанийн нэрээр хайх' // to translate
  },

  warnings: {
    delete: 'Та итгэлтэй байна уу??'
  },

  workshop: {
    title: 'Миний дасгал ажил',
    subtitle: 'Өөрийн курс үүсгэх эсвэл шууд эвент зохион байгуулах',
    new_course: 'Шинэ курс үүсгэх',
    new_scorm_course: 'Шинэ CКОРМ курс байршуулах', // to translate
    upload_scorm_course: 'CКОРМ курс байршуулах', // to translate
    new_event: 'Шинэ шууд эвент үүсгэх',
    new_maze: 'Шинэ мэйз үүсгэх', // to translate
    new_skill_journey: 'Ур чадварын аялал үүсгэх', // to translate
    new_assessment: 'Шинээр шууд үнэлгээ үүсгэх',
    courses_title: 'Үүсгэсэн курсүүд & Шууд эвентүүд',
    courses_subtitle:
      'Үүсгэсэн курс, шууд эвентийн төлөвлөгөөгөө засах & нийтлэх',
    tags_course: 'Курс',
    tags_scorm: 'СКОРМ', // to translate
    tags_live: 'Шууд эвент',
    tags_assessment: 'Шууд үнэлгээ',
    tags_skillJourney: 'Ур чадварын аялал' // to translate
  },

  help_center: {
    sidebar: {
      title: 'Бид танд яаж туслах вэ?',
      back_to: 'Талбар'
    },
    menu: {
      help_center: 'Тусламжийн төв',
      whats_new: 'Шинэ юу байна',
      feedback: 'Санал зөвлөмж',
      feedback_title: 'Sharelook-т санал зөвлөмж илгээх',
      terms_and_conditions: 'Үйлчилгээний нөхцөл',
      privacy_policy: 'Нууцлалын бодлого',
      contact_us: 'Бидэнтэй холбоо барих'
    },
    get_started: {
      title: 'Sharelook-ыг ашиглаж эхлэх',
      new_title: 'Хэрэглэгчийн гарын авлага', // to translate
      description: {
        main:
          'БИД ХЯЛБАР АШИГЛАХ БОЛОМЖТОЙ ХИЧЭЭЛ БЭЛТГЭГЧИД ШУУД ВИДЕО ДАМЖУУЛАЛТЫГ ХОЛБОСОН',
        tagline:
          'ShareLook-ын патенттай шууд дамжуулах системийн тусламжтай та сургалтыг автоматжуулж, олныг хамруулж, мэдлэг түгээх явцыг улам боловсронгуй болгож болно.'
      }
    },
    whats_new: {
      title: 'Sharelook-ыг ашиглаж эхлэх',
      description: {
        main:
          'Түүх өгүүлэх замаар аливааг сурах нь цаг хэмнэхээс гадна хямд төсөр гэдгийг та мэдсэн үү? Та ShareLook-ын курс үүсгэх функц болон бусад үйлчилгээг ашиглаарай. "ХЭРХЭН гэдгийг биднээс асуу.',
        tagline: ''
      }
    },
    create_workshop: 'Дасгал ажил хэрхэн үүсгэх вэ',
    create_course: 'Курс хэрхэн үүсгэх вэ',
    create_user: 'Хэрэглэгч хэрхэн үүсгэх вэ',
    create_group: 'Групп хэрхэн үүсгэх вэ',
    create_webinar: 'Вебинар хэрхэн үүсгэх вэ',
    create_live_event: 'Шууд эвент хэрхэн үүсгэх вэ',
    create_live_assessment: 'Шууд үнэлгээ хэрхэн үүсгэх вэ',
    create_live_on_mobile: 'Гар утас дээр хэрхэн шууд дамжуулах вэ',
    personalize_profile: 'Профайлаа өөрийн болгож засах',
    manage_group: 'Групп удирдах',
    report: 'Тайлан',
    add_annotations: 'Тайлбар/Үсэрч гарч ирдэг хуудас хэрхэн хийх вэ',
    add_audio: 'Хэрхэн аудио нэмэх вэ',
    add_header_and_footer: 'Толгой & хөл хэрхэн нэмэх вэ',
    add_image: 'Зураг хэрхэн нэмэх вэ',
    add_quiz_content: 'Таавар контент хэрхэн нэмэх вэ',
    add_text_content: 'Текст контент хэрхэн нэмэх вэ',
    add_user: 'Хэрэглэгч хэрхэн нэмэх вэ',
    add_video: 'Видео хэрхэн нэмэх вэ',
    clone_course: 'Курсийг хэрхэн клон хийх вэ',
    find_live_broadcast: 'Шууд өргөн нэвтрүүлгийг хэрхэн олох вэ',
    transcribe_and_translate_live_broadcast:
      'Шууд өргөн нэвтрүүлгийг орчуулах/хөрвүүлэх', // to translate
    transcribe_and_translate_your_live_broadcast:
      'Шууд өргөн нэвтрүүлгийг хэрхэн хөрвүүлж, орчуулах вэ', // to translate
    contact_us: {
      title: 'Бидэнтэй холбоо барих',
      subject_placeholder: 'Гарчиг оруулна уу*',
      content_placeholder: 'Мессежээ оруулна*',
      subject_required: '*Гарчиг оруулах шаардлагатай',
      content_required: '*Мессеж оруулах шаардлагатай',
      submit: 'Илгээх',
      cancel: 'Цуцлах',
      sent: 'Илгээсэн'
    },
    feedback: {
      title: 'Sharelook-т санал зөвлөмж илгээх',
      attach_title: 'Файл хавсаргах',
      choose: 'Файл сонгох',
      detail: 'Тусламжийн багт файлыг хуваалцана',
      content_placeholder: ' Мессеж оруулна уу*',
      content_required: '*Мессеж оруулах шаардлагатай',
      submit: 'Илгээх',
      cancel: 'Цуцлах',
      sent: 'Илгээсэн'
    }
  },
  discussion: {
    join_discussion: 'Хэлэлцүүлэгт нэгдэх'
  },
  notes: {
    title: 'Миний тэмдэглэлүүд',
    add_note: 'Шинэ тэмдэглэл нэмэх'
  },
  // added_third
  groups: {
    search_group: 'Байгууллагын группийг хайх' // to translate
  },
  /* Information object is to be translated */
  v4: {
    title: 'Та өнөөдөр юу хийхийг хүсэж байна вэ?', // to translate
    build_course: 'Курсээ бий болгох', // to translate
    live_broadcast: 'Шууд өргөн нэвтрүүлэг', // to translate
    invite_users: 'Байгууллагадаа хэрэглэгчид урих', // to translate
    build_voice_over: 'Дуу оруулалтаа үүсгэх', // to translate
    view_reports: 'Тайлан харах', // to translate
    upload_media: 'Медиа эсхүл ажлаа байршуулах болон хуваалцах', // to translate
    main_menu: 'Үндсэн цэс', // to translate
    get_started: 'ЭХЛЭХ' // to translate
  }
  /* To Translate  */
}
